import React, {useEffect} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {useLocation} from 'react-router-dom';

import AddEditSaleAgentBottomSheet from '../addEditSaleAgentBottomSheet';
import DeleteSaleAgentBottomSheet from '../deleteSaleAgentBottomSheet';
import EditDeleteSaleAgentBottomSheet from '../editDeleteSaleAgentBottomSheet';

function OperationSaleAgentBottomSheet({
  saleAgentsBottomSheet,
  setSaleAgentsBottomSheet,
  refetchGetSaleAgentList,
  assigner_store,
  cardGuid,
}: IAdvertisementTypesBottomSheet) {
  const {state} = useLocation();


  useEffect(() => {
    setSaleAgentsBottomSheet({...saleAgentsBottomSheet, cardGuid: cardGuid});
  }, [state, state?.cardGuid]);

  return (
    <BottomSheet
      onDismiss={() =>
        setSaleAgentsBottomSheet({
          ...saleAgentsBottomSheet,
          position: false,
          type: 'addEdit',
        })
      }
      open={saleAgentsBottomSheet.position}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      {handleShowModals(
        saleAgentsBottomSheet,
        setSaleAgentsBottomSheet,
        refetchGetSaleAgentList,
        assigner_store,
      )}
    </BottomSheet>
  );
}

export default OperationSaleAgentBottomSheet;

const handleShowModals = (
  saleAgentsBottomSheet: ISaleAgentBottomSheetProps,
  setSaleAgentsBottomSheet: React.Dispatch<
    React.SetStateAction<ISaleAgentBottomSheetProps>
  >,
  refetchGetSaleAgentList?: () => void,
  assigner_store?: string,
) => {
  switch (saleAgentsBottomSheet.type) {
    case 'editDelete':
      return (
        <EditDeleteSaleAgentBottomSheet
          {...{
            setSaleAgentsBottomSheet,
            saleAgentsBottomSheet,
            refetchGetSaleAgentList,
          }}
        />
      );
    case 'addEdit':
      return (
        <AddEditSaleAgentBottomSheet
          {...{
            setSaleAgentsBottomSheet,
            saleAgentsBottomSheet,
            refetchGetSaleAgentList,
            assigner_store,
          }}
        />
      );
    case 'delete':
      return (
        <DeleteSaleAgentBottomSheet
          {...{
            setSaleAgentsBottomSheet,
            saleAgentsBottomSheet,
            refetchGetSaleAgentList,
          }}
        />
      );
  }
};
